import { Directive, ElementRef, Host, HostListener, Input, OnDestroy } from '@angular/core';
import { TooltipPosition } from './tooltip-position.enum';

@Directive({ selector: '[toolTip]' })
export class TooltipDirective implements OnDestroy {
  @Input('toolTip') tooltipText: string = '';
  @Input('toolTipPosition') toolTipPosition: TooltipPosition = TooltipPosition.TOP;
  @Input('toolTipDisabled') toolTipDisabled: boolean = false;
  private tooltipElement!: HTMLDivElement | null;

  constructor(private el: ElementRef<HTMLElement>) { }

  ngOnDestroy(): void {
    this.destroyTooltip();
  }

  @HostListener('mouseenter') onMouseEnter() {
    this.createTooltip();
  }

  @HostListener('mouseleave') onMouseLeave() {
    this.destroyTooltip();
  }

  @HostListener('click') onClick() {
    this.destroyTooltip();
  }

  private createTooltip() {
    if (this.toolTipDisabled) return;

    const tooltip = document.createElement('div');
    this.tooltipElement = tooltip;

    tooltip.style.position = 'fixed';
    tooltip.style.zIndex = '9999';
    tooltip.style.color = 'var(--color-4)';
    tooltip.style.border = 'var(--border)';
    tooltip.style.borderColor = 'var(--color-3)';
    tooltip.style.borderRadius = 'var(--border-radius-smol)';
    tooltip.style.padding = '0.5rem';
    tooltip.style.fontSize = 'var(--size-6)';
    tooltip.style.whiteSpace = 'nowrap';
    tooltip.style.boxShadow = 'var(--box-shadow-dark)';
    tooltip.style.backgroundColor = 'var(--color-1)';
    tooltip.classList.add('fade-in-tooltip');
    tooltip.innerHTML = this.tooltipText;

    document.body.appendChild(tooltip);

    const targetRect = this.el.nativeElement.getBoundingClientRect();
    const tooltipRect = tooltip.getBoundingClientRect();
    const spacing = 8; // px 

    const centerX = targetRect.left + targetRect.width / 2;
    const centerY = targetRect.top + targetRect.height / 2;
    let left = centerX - tooltipRect.width / 2;
    let top = targetRect.top - tooltipRect.height - spacing;

    switch (this.toolTipPosition) {
      case TooltipPosition.TOP:
        break;

      case TooltipPosition.BOTTOM:
        top = targetRect.bottom + spacing;
        break;

      case TooltipPosition.LEFT:
        left = targetRect.left - tooltipRect.width - spacing;
        top = centerY - tooltipRect.height / 2;
        break;

      case TooltipPosition.RIGHT:
        left = targetRect.right + spacing;
        top = centerY - tooltipRect.height / 2;
        break;
    }

    const viewportWidth = document.documentElement.clientWidth;
    const viewportHeight = document.documentElement.clientHeight;
    const maximumLeft = Math.max(spacing, viewportWidth - tooltipRect.width - spacing);
    const maximumTop = Math.max(spacing, viewportHeight - tooltipRect.height - spacing);
    tooltip.style.left = `${Math.min(Math.max(left, spacing), maximumLeft)}px`;
    tooltip.style.top = `${Math.min(Math.max(top, spacing), maximumTop)}px`;
  }

  private destroyTooltip() {
    if (this.tooltipElement) {
      document.body.removeChild(this.tooltipElement);
      this.tooltipElement = null;
    }
  }
}
